import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    TITLE: 'Widget',
    hoy: 'Hoy',
    t_registrado: 'T. registrado',
    marcar_ingreso: 'Marcar ingreso',
    iniciar_almuerzo: 'Iniciar almuerzo/descanso',
    finalizar_almuerzo: 'Finalizar almuerzo/descanso',
    salir: 'Salir',
    error_carga_title: 'Ocurrio un error en la carga',
    error_carga_desc:
      'Haz clic en el boton para intentar cargar el contenido nuevamente.',
    reintentar: 'Reintentar',
    ingreso: 'Ingreso',
    inicio_almuerzo_descanso: 'Inicio de almuerzo/descanso',
    fin_almuerzo_descanso: 'Fin de almuerzo/descanso',
    salida: 'Salida',
    sin_registro: 'Sin registro',
    registro_recibido: 'Registro recibido',
    cancelar: 'Cancelar',
    continuar: 'Continuar',
    alerta_sin_turno_title: '¿Estas seguro de registrar tu entrada?',
    alerta_sin_turno_desc:
      'Aun no tienes un turno asignado para hoy; puedes continuar con el registro y contactar a tu administrador para obtener mas informacion.',
    alerta_ingreso_no_iniciado_title: '¿Estas seguro de registrar tu entrada?',
    alerta_ingreso_no_iniciado_desc:
      'Estas registrando tu entrada fuera del horario asignado, ya que la hora de ingreso de tu proximo turno aun no ha iniciado.',
    alerta_salida_antes_title: '¿Estas seguro de registrar tu salida?',
    alerta_salida_antes_desc:
      'Salir antes de tu horario podria afectar tu asistencia, por lo que te sugerimos reportar cualquier eventualidad a tu administrador.',
    detalles_del_registro: 'Detalles del registro',
    dia: 'Dia',
    turno_asignado: 'Turno asignado',
    evento_registrado: 'Evento registrado',
    hora_del_registro: 'Hora del registro',
    hora_estimada: 'Hora estimada',
    hora_registro_tooltip:
      'La hora de registro puede ajustarse automaticamente segun las reglas de tu empresa. Consulta con tu administrador para mas informacion.',
    success_ingreso: 'Has registrado tu ingreso correctamente.',
    success_salida: 'Has registrado tu salida correctamente.',
    success_break_start:
      'Has registrado tu inicio de almuerzo/descanso correctamente.',
    success_break_end:
      'Has registrado tu fin de almuerzo/descanso correctamente.',
    warning_late:
      'Has registrado tu {{event}} despues del horario establecido.',
    warning_early: 'Has registrado tu {{event}} antes del horario establecido.',
    error_generic:
      'Hubo un error al registrar la asistencia, intentalo nuevamente.',
    error_duplicate:
      'Este evento ya fue registrado en otro dispositivo y no es posible marcarlo de nuevo.',
    cerrar: 'Cerrar',
    sin_turno: 'Sin turno asignado',
    tiempo_registrado: 'Tiempo registrado',
    tiempo_esperado: 'Tiempo esperado',
    registro_fuera_rango: 'Registro fuera del rango esperado',
    mi_asistencia: 'Mi asistencia',
    mi_equipo: 'Mi equipo',
    ver_modulo: 'Ver modulo',
    registra_tu_asistencia: 'Registra tu asistencia para el turno de hoy.',
    turno_completado: 'Turno completado',
    a_tiempo: 'A tiempo',
    aceptable: 'Aceptable',
    retardo_o_falta: 'Retardo o falta',
    salida_anticipada: 'Salida anticipada',
    fuera_de_horario: 'Fuera de horario',
    sin_calculo: 'Sin calculo',

    // new keys

    date_time_display_today: 'Hoy',

    registered_mark_modal_title: 'Detalles del registro',
    registered_mark_modal_success_banner_message:
      'Has registrado tu {{markName}} correctamente.',
    registered_mark_modal_delay_banner_message:
      'Has registrado tu {{markName}} después del horario establecido.',
    registered_mark_modal_early_banner_message:
      'Has registrado tu {{markName}} antes del horario establecido.',
    registered_mark_modal_error_default:
      'Hubo un error al registrar la asistencia, inténtalo nuevamente.',
    registered_mark_modal_error_duplicate:
      'Este evento ya fue registrado en otro dispositivo y no es posible marcarlo de nuevo.',

    registered_mark_modal_row_without_shift: 'Sin turno asignado',
    registered_mark_modal_row_day: 'Dia',
    registered_mark_modal_row_shift: 'Turno asignado',
    registered_mark_modal_row_event: 'Evento registrado',
    registered_mark_modal_row_time: 'Hora del registro',
    registered_mark_modal_row_estimated_time: 'Hora estimada',
    registered_mark_modal_row_tooltip:
      'La hora de registro puede ajustarse automaticamente según las reglas de tu empresa. Consulta con tu administrador para más información.',
    registered_mark_modal_row_retry: 'Reintentar',
    registered_mark_modal_row_cancel: 'Cancelar',

    timer_circle_today: 'Hoy',
    timer_circle_hours_outside_schedule: 'Horas fuera del rango esperado',
    timer_circle_t_registered: 'T. registrado',
    timer_circle_time_registered: 'Tiempo registrado',
    timer_circle_time_expected: 'Tiempo esperado',

    dialog_button_continue: 'Continuar',
    dialog_button_cancel: 'Cancelar',

    confirm_mark_no_shift_title: '¿Estas seguro de registrar tu entrada?',
    confirm_mark_no_shift_description:
      'Aun no tienes un turno asignado para hoy; puedes continuar con el registro y contactar a tu administrador para obtener mas informacion.',
    confirm_mark_early_entry_title: '¿Estas seguro de registrar tu entrada?',
    confirm_mark_early_entry_description:
      'Estas registrando tu entrada fuera del horario asignado, ya que la hora de ingreso de tu proximo turno aun no ha iniciado.',
    confirm_mark_early_exit_title: '¿Estas seguro de registrar tu salida?',
    confirm_mark_early_exit_description:
      'Salir antes de tu horario podria afectar tu asistencia, por lo que te sugerimos reportar cualquier eventualidad a tu administrador.',

    mark_event_entry: 'Ingreso',
    mark_event_break_start: 'Inicio de almuerzo/descanso',
    mark_event_break_end: 'Fin de almuerzo/descanso',
    mark_event_exit: 'Salida',

    action_buttons_mark_entry: 'Marcar ingreso',
    action_buttons_mark_break_start: 'Iniciar almuerzo/descanso',
    action_buttons_mark_break_end: 'Finalizar almuerzo/descanso',
    action_buttons_mark_exit: 'Salir',

    widget_header_tabs_personal: 'Mi asistencia',
    widget_header_tabs_team: 'Mi equipo',
    widget_header_link_view_module: 'Ver módulo',

    widget_no_leader_title: 'Mi asistencia',
    widget_no_leader_subtitle: 'Registra desde aqui el turno de hoy.',

    team_table_column_user: 'Usuario',
    team_table_column_shift: 'Turno',
    team_table_column_status: 'Estado',
    team_table_column_scheduled_time: 'Horario programado',

    team_table_status_without_mark: 'Sin registro',
    team_table_status_entry_marked: 'Ingresó',
    team_table_status_break_start_marked: 'En almuerzo / descanso',
    team_table_status_break_end_marked: 'Volvió del almuerzo / descanso',
    team_table_status_exit_marked: 'Salió',
    team_table_status_shift_break: 'Descanso de turno',
    team_table_status_without_shift: 'Sin turno asignado',

    team_table_scheduled_time_not_applicable: 'No aplica',

    team_table_error_title: 'Ocurrió un error al cargar',
    team_table_error_description:
      'Haz clic en el botón para intentar cargar el contenido nuevamente.',
    team_table_error_retry: 'Reintentar',
    team_table_empty_title: 'Sin miembros del equipo',
    team_table_empty_description: 'No hay miembros del equipo para mostrar.',
  },
};
